// Статус обращения глазами сотрудника филиала (handoff 02-screens p6, 11-acceptance «Страница
// «Обращения филиала»»). Тон - ключ цвета: new, work, wait, done - полоска и слово статуса,
// muted - серым, idea - серым с лампочкой. Чистые функции: проверяет скрипт, тестов в webcrm нет.

/** Решено, а оценки нет: «ожидает вашей оценки» в списке, «ждём оценку» в панели. */
export function awaitingRating (appeal) {
  return appeal.type === 'issue' && appeal.status === 'solved' && !appeal.rating
}

/** Слово статуса для карточки списка: { label, tone, extra }; extra - розовая приписка. */
export function statusView (appeal) {
  if (appeal.type === 'idea' || appeal.status === 'idea') {
    return { label: 'Идея · передана команде FAKT', tone: 'idea', extra: null }
  }

  switch (appeal.status) {
    case 'new':
      return { label: 'Новое', tone: 'new', extra: null }
    case 'work':
      return { label: 'В работе', tone: 'work', extra: null }
    case 'wait_user':
      return { label: 'Ждёт вашего ответа', tone: 'wait', extra: null }
    case 'solved':
      return appeal.rating
        ? { label: `Решено · ★ ${appeal.rating.score}`, tone: 'done', extra: null }
        : { label: 'Решено', tone: 'done', extra: 'ожидает вашей оценки' }
    case 'archived':
      // Цвет «Закрыто без ответа» в макете не задан: серым, как прочее закрытое без решения.
      return { label: 'Закрыто без ответа', tone: 'muted', extra: null }
    default:
      // Черновик в списках не бывает (бэк его не отдаёт); на всякий случай без подписи.
      return { label: '', tone: 'muted', extra: null }
  }
}

/** Правая панель тикета: у неоценённого решения - «Решено · ждём оценку» (Q36). */
export function panelStatus (appeal) {
  return awaitingRating(appeal) ? 'Решено · ждём оценку' : statusView(appeal).label
}

/** Чип статуса в строке пути: без розовой приписки. */
export function chipStatus (appeal) {
  return statusView(appeal).label
}

/**
 * Кто в чипе специалиста: person - аватар и имя, studying - серый «?» и «изучаем» (Q29),
 * team - «Команда FAKT» у идеи.
 */
export function assigneeKind (appeal) {
  if (appeal.type === 'idea' || appeal.status === 'idea') return 'team'

  return appeal.assignee ? 'person' : 'studying'
}

/**
 * «Проблема решена» - у открытого обращения-проблемы, включая «Новое»: филиал мог справиться сам,
 * не дожидаясь ответа поддержки (решение владельца 2026-10-15). Та же проверка в виджете.
 */
export function canSolve (appeal) {
  return appeal.type === 'issue' && ['new', 'work', 'wait_user'].includes(appeal.status)
}

/** Закрыто: поле ответа с подсказкой «Если проблема вернётся - напишите сюда…». */
export function isClosed (appeal) {
  return appeal.status === 'solved' || appeal.status === 'archived'
}
